import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { Button } from '@shared/ui/Button'
import { TextField } from '@shared/ui/TextField'
import { nameSchema, type NameFormValues } from './name.schema'
import styles from './NameStep.module.css'

interface NameStepProps {
  /** Стартовое значение имени */
  initialName?: string
  /** Обработчик отправки валидного имени (уже обрезанного) */
  onSubmit: (name: string) => Promise<void>
  /** Идёт ли отправка */
  isSubmitting?: boolean
  /** Серверная ошибка */
  errorText?: string | null
}

/**
 * Шаг ввода имени пользователя (для онбординга новых юзеров).
 * @param initialName - Стартовое значение поля
 * @param onSubmit - Колбэк с валидным именем
 * @param isSubmitting - Идёт ли отправка
 * @param errorText - Серверная ошибка
 */
export const NameStep = ({
  initialName = '',
  onSubmit,
  isSubmitting = false,
  errorText = null
}: NameStepProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid }
  } = useForm<NameFormValues>({
    resolver: yupResolver(nameSchema),
    mode: 'onChange',
    defaultValues: { name: initialName }
  })

  const submit = async (values: NameFormValues) => {
    await onSubmit(values.name)
  }

  return (
    <form onSubmit={handleSubmit(submit)} className={styles.form} noValidate>
      <h1 className={styles.title}>What’s your name?</h1>

      <TextField
        id="user-name"
        autoFocus
        placeholder="Your name"
        maxLength={128}
        errorText={errors.name?.message}
        {...register('name')}
      />

      {errorText && <span className={styles.error}>{errorText}</span>}

      <Button type="submit" disabled={!isValid || isSubmitting} block>
        {isSubmitting ? 'Saving…' : 'Continue'}
      </Button>
    </form>
  )
}
